import { connect } from 'react-redux';

import {
    mapDispatchToProps as sourceMapDispatchToProps,
    mapStateToProps,
    MenuItemContainer as SourceMenuItemContainer
} from 'SourceComponent/MenuItem/MenuItem.container';
import { resetState } from 'Store/ProductList/ProductList.action';

// eslint-disable-next-line @scandipwa/scandipwa-guidelines/create-config-files
export const HOVER_TIME_OUT = 0; // Setting it to 0 since it intervenes with hover intent made in MEEA-826

/** @namespace Scandipwa/Component/MenuItem/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    ...sourceMapDispatchToProps(dispatch),
    resetState: () => dispatch(resetState())
});

/** @namespace Scandipwa/Component/MenuItem/Container */
export class MenuItemContainer extends SourceMenuItemContainer {
    state = {
        notActive: true,
        isTimeOut: false,
        isTopItemHovered: false,
        xd: false,
        hovered: false
    };

    containerProps() {
        const {
            device,
            isDeviceDesktop,
            closeMenu,
            onCategoryClick,
            isParent,
            isHighlighted,
            handleSliderItemHover,
            isSmall,
            resetState
        } = this.props;

        return {
            ...super.containerProps(),
            device,
            isDeviceDesktop,
            closeMenu,
            onCategoryClick,
            isParent,
            isHighlighted,
            handleSliderItemHover,
            isSmall,
            resetState
        };
    }

    handleCategoryHover(isItemHovered = false) {
        const { onCategoryHover, item, activeMenuItemsStack } = this.props;

        const timeOut = isItemHovered && activeMenuItemsStack.length === 0 ? HOVER_TIME_OUT : 0;

        if (!isItemHovered) {
            clearTimeout(this.menuHoverTimeOut);

            return null;
        }

        this.setState({
            notActive: false
        });

        this.menuHoverTimeOut = setTimeout(() => {
            onCategoryHover(item);
        }, timeOut);

        return this.menuHoverTimeOut;
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MenuItemContainer);
